module.exports = __webpack_public_path__ + "static/img_link_card_02@2x-945822bf399f4662c46386dc15c077b8.png";